import { z } from 'zod';
import { CardEnum } from '../CardState.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
export const mechanicMerchantStateSchema = z.object({
    owner: z.enum(PlayerColor).exclude([
        'None'
    ]).exactOptional(),
    locationTileIndex: z.union([
        z.number().int().nonnegative(),
        z.null()
    ]).exactOptional(),
    activeTradeBonus: z.union([
        z.enum(CardEnum),
        z.null()
    ]).exactOptional(),
    isMerchantOwnerDisplacingMerchant: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional()
}).strict();
export function validateMechanicMerchantState(data) {
    return validateState(mechanicMerchantStateSchema, data);
}
export const mechanicMerchantStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicMerchantStateSchema);
